import React from "react";
import { logoff } from "_services/oauth";
import { useHistory } from "react-router-dom";
export default function LogoutPage() {
  const history = useHistory();
  
  React.useEffect(() => {

    logoff();
     
    history.push("/auth/login-page");
  },[]);



  return (
    <>test</>
  );
}
